import React, { useState } from 'react';
import Ticket from "../../modules/TicketManagement/Ticket.css"
import { MyTickets, RaisedTickets } from "./TicketTable"


const TicketsManagement = () => {


    const [toggleState, setToggleState] = useState(1);
    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'My Tickets';
            case 2:
                return 'Raised Tickets';
            // case 3:
            //     return 'Custom Expense Excel';
            default:
                return 'My Tickets';
        }
    };

    return (
        <>
            {/* <Dashboardnavbar name={getSelectedTitle()} url="Tickets Managment" /> */}

            <div className="bloc-tabss2  wfm-margin">
                <button
                    className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                    onClick={() => setToggleState(1)}
                >
                    My Tickets
                </button>
                < button
                    className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                    onClick={() => setToggleState(2)}
                >
                    Raised Tickets
                </button>

            </div>


            <div>
                {toggleState === 1 ? <MyTickets /> : null}
                {toggleState === 2 ? <RaisedTickets /> : null}
                {/* {toggleState === 3 ? <ImprestExpenseCustomData /> : null} */}
            </div>
        </>
    );
};

export default TicketsManagement;